import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type { EligibilityOutcome } from '@/types/qualification-eligibility.types'
import type {
  EvaluateEligibilityRequest,
  PutScheduleQualificationPolicyRequest,
  ScheduleQualificationPolicyResponse
} from '@/types/qualification-policy.types'

/**
 * Qualificação exigida por escala (SPEC §6.3) e pré-checagem da alocação (A8). Com a flag do
 * backend desligada as três rotas respondem 404 `PROFESSIONAL_DOCUMENTS_DISABLED`: o erro sobe
 * e quem chama decide com `isProfessionalDocumentsDisabled` (R2.5).
 */
export default class QualificationEligibilityService extends Service {
  constructor() {
    super()
    this.prefix = '/qualification-eligibility'
  }

  async getSchedulePolicy(scheduleId: number): Promise<ScheduleQualificationPolicyResponse> {
    try {
      const { data } = await request.get<ScheduleQualificationPolicyResponse>(
        `/schedules/${scheduleId}/qualification-policy`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar a qualificação exigida da escala')
    }
  }

  /** Fecha o vínculo vigente e abre outro a partir de `validFrom` (D61). 409 = mesma data. */
  async putSchedulePolicy(
    scheduleId: number,
    body: PutScheduleQualificationPolicyRequest
  ): Promise<ScheduleQualificationPolicyResponse> {
    try {
      const { data } = await request.put<ScheduleQualificationPolicyResponse>(
        `/schedules/${scheduleId}/qualification-policy`,
        body
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível salvar a qualificação exigida da escala')
    }
  }

  /** Tetos do backend: ≤ 200 plantões, ≤ 2000 médicos e ≤ 5000 pares por chamada (A8). */
  async evaluate(body: EvaluateEligibilityRequest): Promise<EligibilityOutcome[]> {
    try {
      const { data } = await request.post<EligibilityOutcome[]>(
        this.getCompletePath('/evaluate'),
        body
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível verificar a qualificação dos médicos')
    }
  }
}
